import desktopApp from "./App.desktop";
import iosApp from "./App.ios";
export { default as appSelectors } from "./selectors";

let App = null;

// #!if iOS === true
// App = iosApp;
// #!else
App = desktopApp;
// #!endif

export default App;
